const storedFields = ["nome", "apelido", "email", "phone", "customer_type", "customerId"];
const numberOfStudentsInput = document.querySelector("#quantos-encarregado");
const encarregadoFields = document.querySelector("#encarregado-fields");
const completarPerfilForm = document.querySelector("#completar-perfil-form");
const completarPerfilBtn = document.querySelector("#completar-perfil-btn");
const customerId = document.querySelector("#customerId");
const continenteCardInput = document.querySelector("#continente-card");
let continenteCardValue = "";
let continenteCardValidated = false;
const continentePhoneInput = document.querySelector("#cc-phone");
const loaderModal = document.querySelector("#full-page-loader-modal");
const formModal = document.querySelector("#criar-conta-popup");
const modalText = formModal.querySelector(".modal-heading__text span");
const studentBirthdaySelect = document.querySelector("#student-birth-date");
const studentSchoolYearBlock = document.querySelector("#aluno-ano-escolar-block");
const progressBlock = document.querySelector(".fixed-to-top");
const progressBar2 = document.querySelector(".bar-2");
const progressBar3 = document.querySelector(".bar-3");
const customerTypeSelect = document.querySelector("#select-customer-type");
const customerTypeOptions = document.querySelector(".customer-type-options");
const customerTypeLabels = document.querySelectorAll(".customer-type-options label");
const comprovativoFile = document.querySelector("#comprovativo");
const profileSection = document.querySelector(".profile-section");
let regCustomerType = document.querySelector("#reg-customer-type")?.value || "";
const messagePopup = document.querySelector('#modal-message-popup');

const isDevEnv = location?.href.startsWith('http://127.0.0.1');
let customerEmailValue = document.querySelector("#email")?.value || "";
const schoolYears = [];
let sonaeBooksUserData = {};
let ccNonce = "";
let publicKey = null;
let sonaeBooksFormSubmitted = false;

document.addEventListener("DOMContentLoaded", async (e) => {
    let customerInfo = localStorage.getItem("customer-info");
    customerInfo = JSON.parse(customerInfo || null);

    if (!customerInfo && !customerEmailValue && !isDevEnv) {
        location.assign("/pages/criar-conta");
    }
    else if (customerEmailValue && !regCustomerType) 
    {
        document.querySelector(".bio-section").style.display = "block";
        document.querySelector(".profile-section").classList.add("desktopMargin");
        progressBlock.classList.add("fixed-to-top-yellow");
        progressBar2.classList.remove("progress-done");

    }
    else if (customerInfo)
    {
        storedFields.forEach((field) => {
            const element = document.querySelector(`input[name=${field}]`);
            element.value = customerInfo[field];
        });
        customerEmailValue = customerInfo["email"];
        regCustomerType = customerInfo["customer_type"];
        continentePhoneInput.value = customerInfo["phone"] || "";

        if (customerInfo?.hasOwnProperty("customer_type")) {
            showCustomerTypeFields(customerInfo["customer_type"]);
        }
    }

    if (regCustomerType) {
        document.querySelector("input[name=customer-type]").value = regCustomerType;
        document.querySelector("input[name=customer_type]").value = regCustomerType;
        showCustomerTypeFields(regCustomerType);
    }


    const birthYearOptions = getBirthYearOptions(16);
    const birthYearOptions1 = getBirthYearOptions();
    const encarregadoBirthYearSelect = document.querySelector("#encarregado-birth-date");
    const studentBirthYearSelect = document.querySelector("#student-birth-date");
    encarregadoBirthYearSelect?.replaceChildren(...birthYearOptions1);
    studentBirthYearSelect?.replaceChildren(...birthYearOptions);

    try {
        const publicKeyRes = await fetch(`/apps/sonae-stores-app/public-key`, {
            method: "POST",
        });
        if (publicKeyRes.ok) {
            const publicKeyJson = await publicKeyRes.json();
            publicKey = publicKeyJson?.data?.key;
        }
    } catch (error) {
        console.error("Error fetching public key:", error);
    }

    await getSonaeBooksUserData();

    //Fetch school details
    fetch('https://sonae-services.production.theloop.tech/forms/schools/details', {
      headers: {
        Client: 'note_forms',
        Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv',
      }
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log({data});
        const studentAnoEscolar = document.querySelector('#ano-escolar-student');
        const encarregadoAnoEscolar = document.querySelector('#encarregado-ano-escolar');

        data?.school_years.forEach((elem) => {
          schoolYears.push(elem);
          const option1 = document.createElement('option');
          option1.value = elem;
          option1.textContent = elem;
          const option2 = document.createElement('option');
          option2.value = elem;
          option2.textContent = elem;
          
          if (studentAnoEscolar) {
            const yearValue = +(elem.split(".")[0]);
            if (yearValue >= 10) {
                studentAnoEscolar.appendChild(option1);
            }
          }

          if (encarregadoAnoEscolar) {
            encarregadoAnoEscolar.appendChild(option2);
          }
        });


        const cicloDeEnsinoSelect = document.getElementById('ciclo_de_ensino');
        if (cicloDeEnsinoSelect) {
          for (const [key, value] of Object.entries(data.teaching_cycles)) {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = key;
            cicloDeEnsinoSelect.appendChild(option);
          }
        }

        // Populate Area de Ensino
        const areaDeEnsinoSelect = document.getElementById('area_de_ensino');
        if (areaDeEnsinoSelect) {
          for (const [key, value] of Object.entries(data.subjects)) {
            const option = document.createElement('option');
            option.value = key;
            option.textContent = value;
            areaDeEnsinoSelect.appendChild(option);
          }
        }

        // Populate County
        const countySelect = document.getElementById('concelho');
        if (countySelect) {
          data.counties.forEach((county) => {
            const option = document.createElement('option');
            option.value = county.id;
            option.textContent = county.name;
            countySelect.appendChild(option);
          });
        }
    }).catch((error) => {
        console.error('Error fetching school details:', error);
    });


    customerTypeSelect?.addEventListener("click", (e) => {
        e.preventDefault();
        customerTypeOptions.style.display = "block";
    });

    customerTypeLabels.forEach((lab) => {
        lab.addEventListener('click', async (e) => {
            e.preventDefault();

            customerTypeLabels.forEach((label) => {
                label.querySelector(".option-label")?.classList.remove("active");
            })

            lab.querySelector(".option-label")?.classList.add("active");
            const customerType = lab.dataset.type;
            
            customerTypeSelect.value = lab.dataset.label;
            // console.log({customerType});
            document.querySelector("input[name=customer-type]").value = customerType;
            document.querySelector("input[name=customer_type]").value = customerType;

            showCustomerTypeFields(customerType);
            customerTypeOptions.style.display = "none";

        })
    });

    completarPerfilForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const consentCheckbox = document.querySelector("#data-consent");

        if (!consentCheckbox?.checked) {
            displayModalText("Para efeitos de inscrição no Programa Escola Note! e envio de benefícios e vantagens personalizadas em Cartão Continente necessitamos do teu consentimento.", 3000);

            return false;
        }

        if (!continenteCardValue || !continenteCardValidated) {
            continentePhoneInput.classList.add("input-error");
            return false;
        }

        if (isTeacherAndNoProof()) {
            comprovativoFile.classList.add("input-error");
            profileSection.scrollIntoView({behavior: "smooth"});
            return false;
        }

        const sonaeBooksSuccessful = sonaeBooksFormSubmitted || await submitSonaeBooksForm(e);

        if (sonaeBooksSuccessful) {
            handleSubmitCompletarPerfilForm(e);
        }
    });

    document.querySelectorAll(".encarregado-block").forEach((block) => {
        block.querySelector("#encarregado-birth-date")?.addEventListener("input", (e) => handleEncarregadoDOB(e, block));
    });

    studentBirthdaySelect?.addEventListener("input", (e) => handleEncarregadoDOB(e, studentSchoolYearBlock));

    //Continente card OTP challenge
    document.querySelector("#cc-otp-challenge")?.addEventListener("click", async (e) => {
        e.preventDefault();

        let ccNumber = continentePhoneInput?.value;
        let confirmCCDiv = document.querySelector("#cc-otp-confirm");
        if (!ccNumber) {
            continentePhoneInput.classList.add("input-error");
            return false;
        } else {
            continentePhoneInput.classList.remove("input-error");
        }
        loaderModal.show();

        try {
            const continenteCard = await encryptWithPublicKey(publicKey, ccNumber);

            const otpChallengeRes = await fetch(`/apps/sonae-stores-app/cc-otp-challenge`, {
                method: "POST",
                body: JSON.stringify({ continente_card_phone: continenteCard }),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (otpChallengeRes.ok) {
                const otpChallengeJson = await otpChallengeRes.json();
                // console.log({otpChallengeJson});
                ccNonce = otpChallengeJson?.data?.nonce;
                continenteCardValue = otpChallengeJson?.data?.continente_card;
                messagePopupShow("Código enviado com sucesso", "", true);

                confirmCCDiv.style.display = "flex";
            } else {
                const otpChallengeJson = await otpChallengeRes.json();
                let errorMessage = otpChallengeJson?.data?.message || "Erro";
                let displayMessage = errorMessage?.includes("associado") ? errorMessage : "Cartão inválido" ;
                console.error(errorMessage);
                throw new Error(displayMessage);
            }
            
        } catch (error) {
            let displayMessage = error?.message || "Erro";
            messagePopupShow(displayMessage, "", false);
        } finally {
            loaderModal.hide();
        }
        
    });
    
    document.querySelector("#confirm-cc-otp")?.addEventListener("click", async (e) => {
        e.preventDefault();

        const otpInput = document.querySelector("#verification-code");
        const otpValue = otpInput?.value;
        if (!otpValue) {
            otpInput.classList.add("input-error");
            return false;
        }
        loaderModal.show();

        try {
            const otpValidateRes = await fetch(`/apps/sonae-stores-app/cc-otp-validate`, {
                method: "POST",
                body: JSON.stringify({ otp_code: otpValue, nonce: ccNonce }),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (otpValidateRes.ok) {
                const otpValidateJson = await otpValidateRes.json();
                // console.log({otpValidateJson});
                if (otpValidateJson?.data?.valid || otpValidateJson?.data?.token) {
                    continenteCardValidated = true;
                    messagePopupShow("O código é válido", ``, true);
                    document.querySelector(".cc-valid-msg")?.classList.remove("hide");
                } else {
                    //invalid
                    document.querySelector(".cc-valid-msg")?.classList.add("hide");
                    messagePopupShow("O código é inválido", "", false);
                }
            } else {
                const otpValidateJson = await otpValidateRes.json();
                // console.log({otpValidateJson})
                let errorMessage = otpValidateJson?.data?.message || "Erro";
                throw new Error(errorMessage);
            }
            
        } catch (error) {
            let errorMessage = error?.message || "Erro";
            messagePopupShow(errorMessage, "", false);
        } finally {
            loaderModal.hide();
        }

    });

    //Update Progress bar
    const tealFormObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Element is in view
                // Optionally, stop observing after the first time it comes into view
                // observer.unobserve(entry.target);
                progressBar2.classList.add("progress-done");
                progressBar3.classList.add("progress-done");
                progressBlock.classList.add("fixed-to-top-teal");
            } else {
                // Element is out of view
                progressBar2.classList.remove("progress-done");
                progressBar3.classList.remove("progress-done");
                progressBlock.classList.remove("fixed-to-top-teal");
            }
        });
    }, {});

    window.addEventListener("scrollend", (e) => {
        tealFormObserver.observe(completarPerfilBtn);
    });
    
    const yellowFormObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                progressBlock.classList.add("fixed-to-top-yellow");
            } else {
                progressBlock.classList.remove("fixed-to-top-yellow");
            }
        });
    }, {});

    window.addEventListener("scrollend", (e) => {
        yellowFormObserver.observe(customerTypeSelect);
    });

});

function messagePopupShow(title="", content="", success=true) {
    messagePopup.querySelector(".popup-title").textContent = title;
    messagePopup.querySelector(".content").textContent = content;

    if (success) {
        messagePopup.classList.remove("error");
        messagePopup.classList.add("success");
    } else {
        messagePopup.classList.remove("success");
        messagePopup.classList.add("error");
    }
    messagePopup.show();

    setTimeout(() => {
        messagePopup.hide();
    }, 4000);
}

function isTeacherAndNoProof() {
    let customerType = regCustomerType || document.querySelector("input[name=customer-type]").value;
    const isTeacher = ("Professor Notavel,Professor/Educador").includes(customerType);

    if (isTeacher && comprovativoFile?.value) {
        const fileSize = comprovativoFile.files[0]?.size || 0;
        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

        if (fileSize > MAX_FILE_SIZE) { // 5 MB
            messagePopupShow("O tamanho do ficheiro não deve exceder 5 MB", "", false);
            return true;
        }
    }

    return isTeacher && 
        (!sonaeBooksUserData?.name && !comprovativoFile?.value);
}

async function submitSonaeBooksForm (e = null) {
    e?.preventDefault();
    completarPerfilBtn.setAttribute("disabled", true);
    loaderModal.show();

    const requiredFields =  ["name", "surname", "email", "continente_card", "teaching_cycle", "subject", "county_id", "is_teacher", "rgpd", "birthdate", "role", "school_year", "teacher_proof"];
    try {
        const sonaeBooksFormData = new FormData(completarPerfilForm);
        let isValid = true;
    
        if (sonaeBooksFormData.get("is_teacher") == 'yes') {
            sonaeBooksFormData.set("is_teacher", true);
        } else {
            sonaeBooksFormData.set("is_teacher", false);
        }

        const firstName = document.querySelector("input[name='nome']")?.value;
        const surname = document.querySelector("input[name='apelido']")?.value;
        const continenteCard = await encryptWithPublicKey(publicKey, continenteCardValue);
        let customerType = document.querySelector(`input[name=customer-type]`)?.value;

        if (!firstName || !surname) {
            completarPerfilBtn.removeAttribute("disabled");
            loaderModal.hide();
            messagePopupShow("Nome e Apelido são obrigatórios", "", false);
            return false;
        }

        sonaeBooksFormData.set("name", firstName);
        sonaeBooksFormData.set("surname", surname);
        sonaeBooksFormData.set("continente_card", continenteCard);
        sonaeBooksFormData.set("role", customerType);
        sonaeBooksFormData.set("email", customerEmailValue);
        sonaeBooksFormData.append("rgpd", true);
    
        sonaeBooksFormData.forEach((val, key) => {
            if (!requiredFields.includes(key)) {
                sonaeBooksFormData.delete(key);
            }
            else if (!val) 
            {
                // isValid = false;
                const elem = document.querySelector(`input[name='${key}']`);
                elem?.classList.add("input-error");
            }
        });
        sonaeBooksFormData.delete("apelido");
        sonaeBooksFormData.delete("quantos-encarregado");
        sonaeBooksFormData.delete("encarregado-ano-escolar");

        if (!("Professor/Educador, Professor Notavel").includes(customerType)) {
            sonaeBooksFormData.delete("encarregado-ano-escolar");
        }

        if (sonaeBooksUserData?.id) {
            sonaeBooksFormData.append("profile_id", sonaeBooksUserData.id);
        }


        const allErrorInputs = document.querySelectorAll(".input-error");
        allErrorInputs.forEach((inp) => {
            inp.addEventListener("focusout", (e) => {
                let val = e.target.value;
                if (val) {
                    inp.classList.remove("input-error");
                }
            });
        });
    
        const sonaeBooksRes = await fetch('https://sonae-shopify-app.production.theloop.tech/customer-sonaebooks-account', {
            method: "POST",
            body: sonaeBooksFormData,
        });

        if (!sonaeBooksRes.ok) {
            const resErrors = await sonaeBooksRes.json();
            // console.log({resErrors});
            let errorMessage = resErrors?.message || resErrors?.data?.message || "Sorry an error occurred";

            if (resErrors?.errors?.base) {
                let additionalMsg = resErrors?.errors?.base?.[0] || "";
                errorMessage += additionalMsg ? ` - ${additionalMsg}` : "";
            }

            throw new Error(errorMessage);
        }

        const resData = await sonaeBooksRes.json();
        completarPerfilBtn.removeAttribute("disabled");
        
        if (resData){
            // console.log({resData});
        }
        sonaeBooksFormSubmitted = true;

        return true;

    } catch (error) {
        completarPerfilBtn.removeAttribute("disabled");
        loaderModal.hide();
        messagePopupShow(error?.message || "Erro!", "", false);
        // displayModalText(error?.message || "Erro!", 2000);
        return false;
    }
}

async function handleSubmitCompletarPerfilForm(e = null) {
    e?.preventDefault();

    const requiredFields = ["nome", "apelido", "email"];
    let isFormValid = true;

    // validate required inputs
    requiredFields.forEach((field) => {
        const element = document.querySelector(`input[name=${field}]`);
        if (element && !element.value) {
            isFormValid = false;
            element.classList.add("input-error");
            //remove class when changed
            element.addEventListener("focusout", (e) => {
                let val = e.target.value;
                if (val) {
                    element.classList.remove("input-error");
                }
            });
        }
    });

    if (!isFormValid) {
        loaderModal.hide();
        return false;
    }

    loaderModal.show();

    let customerIdValue = (customerId?.value || "").trim();
    const isCustomerRegistered = Boolean(customerIdValue);
    const customerTypeValue = document.querySelector("input[name=customer-type]")?.value;
    const customerFormObj = {
        metafields: {
            customer_type: customerTypeValue,
        }
    };
    const tenSchoolYearMetafields = [1,2,3,4,5,6,7,8,9,10].map((field) => `encarregado-ano-escolar-${field}`)
    const tenBirthDateMetafields = [1,2,3,4,5,6,7,8,9,10].map((field) => `encarregado-birth-date-${field}`)
    const metafields = {
        all: ["continente-card"],
        student: ["student-birth-date", "ano-escolar-student"],
        professor: ["professor-tamben"],
        encarregado: [
            "quantos-encarregado",
            "encarregado-birth-date",
            "encarregado-ano-escolar",
            ...tenBirthDateMetafields,
            ...tenSchoolYearMetafields,
        ]
    };
    const allMetafields = Object.values(metafields).flat();

    
    const customerFormData= new FormData(completarPerfilForm);
    if (("Aluno,Professor Notavel").includes(customerTypeValue)) {
        customerFormData.delete("quantos-encarregado");
    }
    if (!("Aluno").includes(customerTypeValue)) {
        customerFormData.delete("student-birth-date");
    }

    let encarregadoSchoolYearsString = "";
    let encarregadoBirthDatesString = "";

    customerFormData.forEach((val, key) => {
        if (!allMetafields.includes(key) && requiredFields.includes(key)){
            customerFormObj[key] = val;
        }
        else if (key.includes("encarregado-ano-escolar"))
        {
            encarregadoSchoolYearsString += `${encarregadoSchoolYearsString.length > 0 ? "," : ""}${val}`
        }
        else if (key.includes("encarregado-birth-date"))
        {
            encarregadoBirthDatesString += `${encarregadoBirthDatesString.length > 0 ? "," : ""}${val}`
        }
        else
        {
            switch (key) {
                case "student-birth-date":
                    customerFormObj.metafields["ano_de_nascimento"] = val;
                    break;
                case "ano-escolar-student":
                    customerFormObj.metafields["school_year"] = val;
                    break;
                case "professor-tamben":
                    customerFormObj.metafields["professor_tamben_encarregado"] = val ? "true" : "false";
                    break;
                case "quantos-encarregado":
                    customerFormObj.metafields["quantos_encarregado"] = +val > 0 ? (val + "") : "1" ;
                    break;
                case "continente-card":
                    customerFormObj.metafields["continente_card"] = continenteCardValue;
                    break;

                default:
                    break;
            }
        }
    });
    delete customerFormObj["eu-sou"];

    if (encarregadoBirthDatesString.length > 0) {
        customerFormObj.metafields["encarregado_birth_dates"] = encarregadoBirthDatesString;
    }
    if (isCustomerRegistered) {
        customerFormObj['id'] = customerIdValue;

        customerFormObj['email'] = customerEmailValue;
    }
    if (("Professor Notavel,Professor/Educador").includes(customerTypeValue)){
        customerFormObj.metafields['ciclo_de_ensino'] = document.querySelector("#ciclo_de_ensino")?.value;
        customerFormObj.metafields['area_de_ensino'] = document.querySelector("#area_de_ensino")?.value;
    }
    if (!("Encarregado de Educação,Professor/Educador").includes(customerTypeValue)) {
        delete customerFormObj.metafields["encarregado_birth_dates"];
    } else {
        if (encarregadoSchoolYearsString.length > 0) {
            customerFormObj.metafields["school_year"] = encarregadoSchoolYearsString;
        }
    }


    const encryptedCCNumber = await encryptWithPublicKey(publicKey, continenteCardValue)
    customerFormObj.metafields.continente_card = encryptedCCNumber;
    // console.log({customerFormObj}, JSON.stringify({data: customerFormObj}), tmpCC, JSON.stringify(tmpCC));

    const customerRes = await fetch(`/apps/sonae-stores-app/customer-account?source=bazaar-noteonline.myshopify.com${isCustomerRegistered ? '&isUpdate=true' : ''}`, {
        method: "POST",
        body: JSON.stringify({data: customerFormObj}),
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then((res) => res.json())
    .catch((error) => {
        completarPerfilBtn.removeAttribute("disabled");
        console.log(error);
    });

    if (customerRes){
        completarPerfilBtn.removeAttribute("disabled");

        if (customerRes?.data?.success == false) {
            loaderModal.hide();
            let errorMessage = customerRes?.data?.message || "Erro!";

            if (errorMessage.toLowerCase().includes("phone") && errorMessage.toLowerCase().includes("taken"))
            {
                errorMessage = "Número de telefone já utilizado";
            }
            if (errorMessage.toLowerCase().includes("phone") && errorMessage.toLowerCase().includes("invalid"))
            {
                errorMessage = "Telemóvel inválido";
            }
            if (errorMessage.toLowerCase().includes("email") && errorMessage.toLowerCase().includes("taken"))
            {
                errorMessage = "Este email já está a ser utilizado";
            }
            messagePopupShow(errorMessage, "", false);
            // displayModalText(errorMessage, 3000);
        }
        else
        {
            setTimeout(() => {
                localStorage.removeItem("customer-info");
                
                handleCriarContaWelcomePage(customerTypeValue);
            }, 2000);
        }
    }
}

function handleCriarContaWelcomePage(customerType) {
    let urlParam = "";//sonaeBooksUserData?.name ? "" : "&new=tribo";

    switch (customerType) {
        case "Professor Notavel":
            location.assign(`/pages/obrigado/professor`);
            break;
        case "Aluno":
            location.assign(`/pages/obrigado/aluno`);
            break;
        case "Encarregado de Educação":
            location.assign(`/pages/obrigado/encarregado-de-educação`);
            break;
        case "Professor/Educador":
            location.assign(`/pages/obrigado/professor-educador`);
            break;
    
        default:
            break;
    }

}

async function getSonaeBooksUserData() {

    try {
        const emailInput = document.querySelector('input[name=email]');
        const email = (emailInput.value || "").toLowerCase();
        
        const encodedEmail = encodeURIComponent(email);
    
        const sonaeBooksRes = await fetch(`https://sonae-services.production.theloop.tech/forms/schools?email=${encodedEmail}`, {
            method: "GET",
            headers: {
                Client: 'note_forms',
                Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv',
            }
        })
    
        if (!sonaeBooksRes.ok) {
            throw new Error("Error fetching SonaeBooks details");
        } else {
            sonaeBooksUserData = await sonaeBooksRes.json();
    
            if (sonaeBooksUserData?.name){

                const nameInput = document.querySelector("#nome");
                const surnameInput = document.querySelector("#apelido");
                nameInput.value = sonaeBooksUserData.name;
                surnameInput.value = sonaeBooksUserData.surname;
                continenteCardValue = sonaeBooksUserData.continente_card;

                if (customerTypeSelect?.value?.toLowerCase()?.includes("professor")) {

                    const cicloDeEnsinoOption = document.querySelector(`#ciclo_de_ensino option[value="${sonaeBooksUserData.teaching_cycle}"]`);
                    const areaDeEnsinoOption = document.querySelector(`#area_de_ensino option[value="${sonaeBooksUserData.subject}"]`);
        
                    if (cicloDeEnsinoOption) {
                        cicloDeEnsinoOption.setAttribute("selected", "true");
                    }
                    if (areaDeEnsinoOption) {
                        areaDeEnsinoOption.setAttribute("selected", "true");
                    }
                }
            }
        }
        
    } catch (error) {
        console.error(error);
    }
}

function showCustomerTypeFields (customer_type) {
    document.querySelectorAll(".option-input").forEach((elem) => {
        elem.style.display = "none";
    });
    switch (customer_type) {
        case "Professor Notavel":
            document.querySelectorAll(".option-input[data-type=professor]").forEach((elem) => {
                elem.style.display = "flex";
            });
            break;
        case "Aluno":
            document.querySelector(".option-input[data-type=aluno]").style.display = "flex";
            profileSection?.classList.add("smaller-profile-section");
            break;
        case "Encarregado de Educação":
            document.querySelectorAll(".option-input[data-type=encarregado]").forEach((elem) => {
                elem.style.display = "flex";
            });
            profileSection?.classList.add("smaller-profile-section");
            break;
        case "Professor/Educador":
            document.querySelectorAll(".option-input[data-type=encarregado], .option-input[data-type=professor]")
                .forEach((elem) => {
                    elem.style.display = "flex";
                });
            break;
        default:
            break;
    }

    document.querySelector("label[data-type='Professor/Educador']")?.scrollIntoView({behavior: "smooth"});
}


function getBirthYearOptions(ageLimit = null) {
    const leastYear = !ageLimit ? new Date().getFullYear() : (new Date().getFullYear() - (ageLimit));
    const optionsArr = [];

    for (let yr = leastYear; yr > 2000; yr--) {
        let option = document.createElement("option");
        option.value = yr;
        option.textContent = ''+yr;
        optionsArr.push(option);
    }

    let option1 = document.createElement("option");
    option1.value = "Anterior a 2001";
    option1.textContent = "Anterior a 2001";
    optionsArr.push(option1);

    return optionsArr;
}

function pemToArrayBuffer(pem) {
    const b64 = pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, '').replace(/\n/g, '');
    const binaryDer = window.atob(b64);
    const bytes = new Uint8Array(binaryDer.length);
    for (let i = 0; i < binaryDer.length; i++) bytes[i] = binaryDer.charCodeAt(i);
    return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

async function encryptWithPublicKey(publicKey, message) {
    const keyArrayBuffer = pemToArrayBuffer(publicKey);
    const key = await window.crypto.subtle.importKey(
        'spki',
        keyArrayBuffer,
        {
            name: 'RSA-OAEP',
            hash: 'SHA-256'
        },
        false,
        ['encrypt']
    );
    const encoder = new TextEncoder();
    const messageArrayBuffer = encoder.encode(message);

    const encrypted = await window.crypto.subtle.encrypt(
        { name: 'RSA-OAEP' }, key, messageArrayBuffer
    );

    const encryptedBase64 = arrayBufferToBase64(encrypted);
    return encryptedBase64;
}


numberOfStudentsInput?.addEventListener("keyup", (e) => {
    let encarregadoQuantos = +e.target.value;

    if (!encarregadoQuantos || encarregadoQuantos < 1) {
        encarregadoQuantos = 1;
    } else if (encarregadoQuantos > 10) {
        encarregadoQuantos = 10
        numberOfStudentsInput.value = 10;
    }

    const currentEncarregadoBlocks = document.querySelectorAll(".encarregado-block");
    let blocksLen = currentEncarregadoBlocks?.length;

    if (blocksLen <= encarregadoQuantos) {

        for (let index = blocksLen+1; index <= encarregadoQuantos; index++) {
            createEncarregadoMetafieldElements(index);
        }
    } else {
        for (let index = encarregadoQuantos+1; index <= blocksLen; index++) {
            const elem = document.querySelector(`.encarregado-input-${index}`);
            encarregadoFields.removeChild(elem);
        }
    }
    // encarregadoFields.replaceChildren();

});

function createEncarregadoMetafieldElements (index, birthDateValue = "", schoolYearValue = "") {
    const encarregadoInputDiv = document.createElement("div");
    encarregadoInputDiv.classList.add("encarregado-block", `encarregado-input-${index}`);
    encarregadoInputDiv.dataset.number = index;

    const dateInputRow = document.createElement("div");
    dateInputRow.className = "input-row two-fields";
    dateInputRow.classList.add("option-input");
    dateInputRow.style.display = "flex";

    const dateInputGroup = document.createElement("div");
    dateInputGroup.classList.add("input-group");
    const dateInput = document.createElement("select");
    dateInput.setAttribute("name", `encarregado-birth-date-${index}`);
    dateInput.setAttribute("id", `encarregado-birth-date-${index}`);
    const birthYearOptions = getBirthYearOptions();
    dateInput.replaceChildren(...birthYearOptions);
    if (birthDateValue) {
        dateInput.value = birthDateValue;
    }
    const dateLabel = document.createElement("label");
    dateLabel.setAttribute("for", `encarregado-birth-date-${index}`);
    dateLabel.textContent = `ANO DE NASCIMENTO EDUCANDO ${index}`;
    dateInputGroup.appendChild(dateLabel);
    dateInputGroup.appendChild(dateInput);

    const dateInputGroup2 = document.createElement("div");
    dateInputGroup2.classList.add("input-group");


    const selectInputRow = document.createElement("div");
    selectInputRow.className = "input-row two-fields";
    selectInputRow.classList.add("option-input");
    selectInputRow.style.display = "flex";
    const selectInputGroup = document.createElement("div");
    selectInputGroup.classList.add("input-group");
    const schoolYearSelect = document.createElement("select");
    schoolYearSelect.setAttribute("name", `encarregado-ano-escolar-${index}`);
    schoolYearSelect.setAttribute("id", `encarregado-ano-escolar-${index}`);
    // schoolYearSelect.setAttribute("disabled", "true");
    schoolYears.forEach((elem) => {
        const option1 = document.createElement('option');
        option1.value = elem;
        option1.textContent = elem;

        if (schoolYearValue == elem) {
            option1.setAttribute("selected", "true");
        }

        schoolYearSelect.appendChild(option1);
    });
    const schoolYearSelectLabel = document.createElement("label");
    schoolYearSelectLabel.setAttribute("for", `encarregado-ano-escolar-${index}`);
    schoolYearSelectLabel.textContent = `ANO ESCOLA EDUCANDO ${index}`;
    const hiddenDiv = document.createElement("div");
    hiddenDiv.classList.add("hidden");
    hiddenDiv.appendChild(schoolYearSelectLabel);
    hiddenDiv.appendChild(schoolYearSelect);
    selectInputGroup.appendChild(hiddenDiv);

    const selectInputGroup2 = document.createElement("div");
    selectInputGroup2.classList.add("input-group");

    dateInputRow.appendChild(dateInputGroup);
    dateInputRow.appendChild(selectInputGroup);
    // selectInputRow.appendChild(selectInputGroup);
    // selectInputRow.appendChild(selectInputGroup2);
        
    encarregadoInputDiv.appendChild(dateInputRow);
    encarregadoInputDiv.addEventListener("input", (e) => handleEncarregadoDOB(e, encarregadoInputDiv));
    // encarregadoInputDiv.appendChild(selectInputRow);

    encarregadoFields.appendChild(encarregadoInputDiv);
}


function displayModalText(text, duration = 3000) {
    modalText.textContent = text;
    formModal.show();
    setTimeout(() => {
        formModal.hide();
    }, duration);
}

function calculateAge(dobInput) {

    const dob = new Date(dobInput);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust the age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
    }

    return age;
}

function handleEncarregadoDOB(e, block) {
    const dobInput = e.target.value;
    const ageArr = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];

    if (dobInput == "Anterior a 2001") {
        block.querySelector("select option[value='Ensino Superior']")?.setAttribute("selected", "true")
        return;
    }
    
    const studentAge = calculateAge(dobInput);
    const studentAgeIndex = ageArr.indexOf(studentAge);
    // console.log({dobInput, studentAge, studentAgeIndex});

    block.querySelectorAll(`select option`).forEach((opt) => {
        if (opt.value.startsWith(`${studentAgeIndex}º`)){
            opt.setAttribute("selected", "true");   
        } else {
            opt.removeAttribute("selected");
        }
    });

    if (studentAge > 18) {
        block.querySelector("select option[value='Ensino Superior']")?.setAttribute("selected", "true")
    }

    if (studentAge < 7) {
        block.querySelector("select option[value='Pré-Escolar']")?.setAttribute("selected", "true")
    }

}